export var customCssApiRelativePath = "/helpcenter/snippets/css";
export var customCssApiRelativePathV2 = "/helpcenter/snippets/css/v2";
export var customCssApiValidationV2 = "/apps/helpcenter/validate-custom-css";
export var createCustomCssApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(customCssApiRelativePath);
    var apiUrlV2 = "".concat(baseUrl).concat(customCssApiRelativePathV2);
    return {
        getCustomCss: function (brandId) {
            return http.get("".concat(apiUrl).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        updateCustomCss: function (dto) { return http.put("".concat(apiUrl), dto.data); },
        getCustomCssV2: function (brandId) {
            return http.get("".concat(apiUrlV2).concat(brandId ? "?brandId=".concat(brandId) : ''));
        },
        updateCustomCssV2: function (dto) { return http.put("".concat(apiUrlV2), dto.data); },
        validateCustomCssV2: function (dto) {
            return http.post("https://".concat(dto.tenantDefaultHost).concat(customCssApiValidationV2), { customCss: dto.customCss });
        }
    };
};
//# sourceMappingURL=index.js.map